import { useQuery } from '@tanstack/react-query'
import { fetchPartnerIndustryTypes } from 'utility/queries/partner'

export const usePartnerIndustryTypes = () =>
	useQuery({
		queryKey: ['partnerIndustryTypes'],
		queryFn: () => fetchPartnerIndustryTypes(),
	})
